import { useEffect, useState } from 'react'

export default function OfflineBanner() {
    const [online, setOnline] = useState(navigator.onLine)

    useEffect(() => {
        const goOnline = () => setOnline(true)
        const goOffline = () => setOnline(false)
        window.addEventListener('online', goOnline)
        window.addEventListener('offline', goOffline)
        return () => {
            window.removeEventListener('online', goOnline)
            window.removeEventListener('offline', goOffline)
        }
    }, [])

    if (online) return null

    return (
        <div className="flex items-center justify-center gap-2 bg-danger py-1.5 px-4 text-center text-sm font-medium text-white">
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636a9 9 0 010 12.728m-2.829-2.829a5 5 0 000-7.07m-4.243 4.243a1 1 0 010-1.414" />
            </svg>
            You are offline. Some features may be unavailable.
        </div>
    )
}
